/**
 * The words of a call placed through the office number (piece 35, *Calls through the office number*; piece 21,
 * *Communications seam*; decision 5130): the Call sheet's two choices, the Calling Your Phone page, the note the call
 * leaves and the disclosure the call plays, spread into the one string lookup.
 */
export const CALL_STRINGS = {
  'calls.office.choiceDetail': 'Your phone rings first, then the contact sees the office number',
  'calls.office.phoneChoice': 'Call from this phone',
  'calls.office.checking': 'Checking…',
  'calls.office.button': 'Call Through the Office Number',
  'calls.calling.title': 'Calling Your Phone',
  'calls.calling.intro': 'Answer your phone when it rings. The office number then calls the contact.',
  'calls.calling.contact': 'Calling',
  'calls.state.placing': 'Asking the office line to ring your phone.',
  'calls.state.ringing': 'Ringing.',
  'calls.state.inProgress': 'Connected.',
  'calls.state.completed': 'The call has ended.',
  'calls.state.noAnswer': 'Nobody answered.',
  'calls.state.busy': 'The line was busy.',
  'calls.state.failed': 'The call could not be placed.',
  'calls.state.repMissed': 'Your phone did not answer, so nobody else was called.',
  'calls.note.writing': 'Writing the note on the record.',
  'calls.note.written': 'The note is on the record.',
  'calls.note.late': 'The note will be on the record once the recording arrives.',
  'calls.note.back': 'Back to the Record',
  'calls.poll.failed': 'The call’s state could not be read.',
  'calls.place.refused': 'The office number could not place the call.',
  'calls.place.unsent': 'The call was not placed: the server could not be reached.',
  'calls.note.recording': 'Recording:',
  'calls.note.transcript': 'Transcript',
  'calls.note.outcome.completed': 'Called through the office number.',
  'calls.note.outcome.noAnswer': 'Called through the office number; nobody answered.',
  'calls.note.outcome.busy': 'Called through the office number; the line was busy.',
  'calls.note.outcome.failed': 'Called through the office number; the call failed.',
  'calls.note.recordingMissing': 'The recording did not arrive.',
  'calls.note.transcriptMissing': 'The transcript did not arrive.',
  'calls.note.rep': 'Rep',
  'calls.note.contact': 'Contact',
  'calls.disclosure': 'This call is recorded.',
  // Decisions 11780 and 11781: the inbound call's two endings, its note and its to-do, and the voicemail's spoken defaults.
  'calls.state.missed': 'Nobody answered, and no message was left.',
  'calls.state.voicemail': 'A message was left.',
  'calls.note.outcome.missed': 'A call to the company number; nobody answered and no message was left.',
  'calls.note.outcome.voicemail': 'A call to the company number left a voicemail.',
  'calls.note.outcome.answered': 'A call to the company number was answered.',
  'calls.todo.voicemail': 'Voicemail from {caller}',
  'calls.todo.missed': 'Missed call from {caller}',
  'calls.todo.noTranscript': 'Open Recents to hear it and call them back.',
  'calls.voicemail.greeting': 'Nobody can take your call right now.',
  'calls.voicemail.menu': 'Press 1 to leave a message, or 2 to reach the main line.',
  'calls.voicemail.unknownCaller': 'an unknown number',
  // Decision 11960: the menu's 3, read through its seam only while an adapter is bound; a work order request's to-do and words.
  'calls.todo.serviceVisit': 'Service visit requested by {caller}',
  'calls.todo.serviceVisitRecording': 'Recording: {url}',
  'calls.todo.serviceVisitMessage': 'Open the call to hear the message they leave after the beep.',
  'calls.voicemail.serviceVisitNoted': 'Your service visit request is noted. Leave the details after the beep.',
  // Decision 11782: a reply's From is one of the organization's active numbers the reader may send from.
  'calls.texts.fromRefused': 'A reply leaves only from one of the organization’s active numbers, so nothing was sent.',
} as const;
